export default "__VITE_ASSET__223082ee__"